/* J4U catalog: Shopify owns filtering, sorting and pagination. No local index. */
(function (root, factory) {
  'use strict';
  var catalog = factory();
  if (typeof module === 'object' && module.exports) module.exports = catalog;
  if (root && root.document) {
    root.J4UCatalog = catalog;
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', function () { catalog.mount(root); });
    } else { catalog.mount(root); }
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var API_VERSION = '2026-10';
  var AUTO_BATCH_SIZE = 240;
  var SORTS = {
    'created-descending': { product: 'CREATED_AT', collection: 'CREATED', reverse: true },
    'price-descending': { product: 'PRICE', collection: 'PRICE', reverse: true },
    'price-ascending': { product: 'PRICE', collection: 'PRICE', reverse: false }
  };
  var FIELDS = 'nodes { id title handle vendor onlineStoreUrl availableForSale createdAt ' +
    'featuredImage { url(transform: {maxWidth: 640}) altText width height } ' +
    'priceRange { minVariantPrice { amount currencyCode } maxVariantPrice { amount currencyCode } } ' +
    'compareAtPriceRange { minVariantPrice { amount currencyCode } } ' +
    'variants(first: 1) { nodes { id } } } pageInfo { hasNextPage endCursor }';

  function sortName(value) { return Object.prototype.hasOwnProperty.call(SORTS, value) ? value : 'created-descending'; }
  function quote(value) { return '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; }
  function titleQuery(text) {
    // Treat input as words, never Shopify query syntax supplied by the visitor.
    // Each word must match the title; distinct product IDs remain distinct items.
    var value = String(text || '').normalize('NFKC').trim();
    if (value.length > 200) throw new Error('Please use a search of 200 characters or fewer.');
    return value ? value.split(/\s+/u).map(function (term) { return 'title:' + quote(term); }).join(' AND ') : '';
  }
  function parseState(href, config) {
    var params = new URL(href).searchParams;
    return {
      term: params.get('q') || '',
      hideSold: params.get('j4u_hide_sold') === '1' || params.get('pf_st_stock_status') === 'true' ||
        params.get('filter.v.availability') === '1' || params.get('options[unavailable_products]') === 'hide',
      sort: sortName(params.get('sort_by') || config.defaultSort)
    };
  }
  function stateURL(href, state, config) {
    var url = new URL(href);
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key === 'page' || key === 'j4u_after' || key === 'filter.v.availability' ||
          key === 'options[unavailable_products]' || key.indexOf('pf_') === 0 || key === '_') url.searchParams.delete(key);
    });
    if (config.mode === 'search') {
      url.searchParams.set('q', state.term);
      url.searchParams.set('type', 'product');
    }
    url.searchParams.set('sort_by', sortName(state.sort));
    if (state.hideSold) url.searchParams.set('j4u_hide_sold', '1');
    else url.searchParams.delete('j4u_hide_sold');
    return url.pathname + url.search + url.hash;
  }
  function buildRequest(config, state, after) {
    var sorting = SORTS[sortName(state.sort)];
    var variables = {
      first: 24, after: after || null, reverse: sorting.reverse,
      country: config.country || null, language: config.language || null
    };
    var isCollection = config.mode === 'collection' && config.collectionHandle && config.collectionHandle !== 'all' && !config.vendor && !config.productType;
    var context = '@inContext(country: $country, language: $language)';
    var query;
    if (isCollection) {
      variables.handle = config.collectionHandle;
      variables.sortKey = sorting.collection;
      variables.filters = state.hideSold ? [{ available: true }] : [];
      (config.tags || []).forEach(function (tag) { variables.filters.push({ tag: tag }); });
      query = 'query J4UCollection($first: Int!, $after: String, $handle: String!, $sortKey: ProductCollectionSortKeys!, $reverse: Boolean!, $filters: [ProductFilter!], $country: CountryCode, $language: LanguageCode) ' + context +
        ' { collection(handle: $handle) { products(first: $first, after: $after, sortKey: $sortKey, reverse: $reverse, filters: $filters) { ' + FIELDS + ' } } }';
    } else {
      var terms = [];
      if (config.mode === 'search' && state.term.trim()) terms.push('(' + titleQuery(state.term) + ')');
      if (config.vendor) terms.push('vendor:' + quote(config.vendor));
      if (config.productType) terms.push('product_type:' + quote(config.productType));
      (config.tags || []).forEach(function (tag) { terms.push('tag:' + quote(tag)); });
      if (state.hideSold) terms.push('available_for_sale:true');
      variables.query = terms.join(' AND ');
      variables.sortKey = sorting.product;
      query = 'query J4UProducts($first: Int!, $after: String, $query: String, $sortKey: ProductSortKeys!, $reverse: Boolean!, $country: CountryCode, $language: LanguageCode) ' + context +
        ' { products(first: $first, after: $after, query: $query, sortKey: $sortKey, reverse: $reverse) { ' + FIELDS + ' } }';
    }
    return { query: query, variables: variables };
  }
  function connectionFrom(payload, state, previousCursor) {
    if (!payload || (payload.errors && payload.errors.length)) throw new Error('Products could not be loaded. Please try again.');
    var data = payload.data;
    var connection = data && (data.products || (data.collection && data.collection.products));
    if (!connection || !Array.isArray(connection.nodes) || !connection.pageInfo) throw new Error('Products could not be loaded. Please try again.');
    if (connection.nodes.some(function (product) { return !product || !product.id || (state.hideSold && product.availableForSale !== true); })) {
      // Do not silently show sold items or scan pages if the server ignores a filter.
      throw new Error('Hide Sold could not be applied. Please try again.');
    }
    if (connection.pageInfo.hasNextPage && (!connection.pageInfo.endCursor || connection.pageInfo.endCursor === previousCursor)) {
      throw new Error('The next products could not be loaded. Please try again.');
    }
    return connection;
  }
  function buildCountRequest(config, state, after, fromDate) {
    // Use exactly the same title/scope query as the cards. Search.totalCount and
    // availability facets are capped, so neither is a store-wide count source.
    var request = buildRequest(config, Object.assign({}, state, { hideSold: false, sort: 'created-descending' }), after);
    request.variables.first = 250;
    request.variables.reverse = false;
    if (fromDate) request.variables.query += ' AND created_at:>=' + quote(fromDate);
    request.query = request.query.replace(FIELDS, 'nodes { id availableForSale createdAt } pageInfo { hasNextPage endCursor }');
    return request;
  }
  async function countSearch(config, state, send, onProgress, isCancelled) {
    if (config.mode !== 'search') throw new Error('Only search results are counted.');
    var after = null, fromDate = null, windowSize = 0;
    var total = 0, available = 0, previousDate = null;
    // Only retain IDs at the current timestamp. They avoid double counting at a
    // date-window boundary without retaining the entire catalog in memory.
    var boundaryIDs = new Set();
    while (true) {
      if (isCancelled && isCancelled()) throw new Error('Count cancelled');
      var payload = await send(buildCountRequest(config, state, after, fromDate));
      if (isCancelled && isCancelled()) throw new Error('Count cancelled');
      var c = connectionFrom(payload, { hideSold: false }, after);
      if (c.pageInfo.hasNextPage && !c.nodes.length) throw new Error('The total could not be calculated.');
      c.nodes.forEach(function (p) {
        var date = Date.parse(p.createdAt);
        if (!Number.isFinite(date) || (previousDate !== null && date < previousDate) || typeof p.availableForSale !== 'boolean') throw new Error('The total could not be calculated.');
        if (previousDate !== date) { boundaryIDs.clear(); previousDate = date; }
        if (!boundaryIDs.has(p.id)) { total++; if (p.availableForSale) available++; boundaryIDs.add(p.id); }
      });
      windowSize += c.nodes.length;
      if (onProgress) onProgress({ total: total, available: available, complete: !c.pageInfo.hasNextPage });
      if (!c.pageInfo.hasNextPage) break;
      after = c.pageInfo.endCursor;
      // Restart within a disjoint date window before Shopify's 25,000-object
      // pagination limit. Include the boundary timestamp, deduplicating its IDs.
      if (windowSize >= 20000) {
        var nextDate = new Date(previousDate).toISOString();
        if (nextDate === fromDate) throw new Error('The total could not be calculated.');
        fromDate = nextDate; after = null; windowSize = 0;
      }
    }
    return { total: total, available: available };
  }
  function PageLedger() { this.ids = new Set(); this.cursor = null; this.hasNext = false; this.count = 0; }
  PageLedger.prototype.append = function (connection) {
    var self = this;
    var unique = connection.nodes.filter(function (product) {
      if (self.ids.has(product.id)) return false;
      self.ids.add(product.id); return true;
    });
    self.count += unique.length;
    self.cursor = connection.pageInfo.endCursor;
    self.hasNext = connection.pageInfo.hasNextPage;
    return unique;
  };
  function element(doc, tag, className, text) {
    var node = doc.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function mount(win) {
    var doc = win.document;
    var host = doc.querySelector('[data-j4u-catalog]');
    if (!host || host.dataset.mounted) return;
    host.dataset.mounted = 'true';
    var config = JSON.parse(host.querySelector('[data-j4u-config]').textContent);
    var form = host.querySelector('[data-j4u-controls]');
    var grid = host.querySelector('[data-j4u-products]');
    var status = host.querySelector('[data-j4u-status]');
    var loading = host.querySelector('[data-j4u-loading]');
    var sentinel = host.querySelector('[data-j4u-sentinel]');
    var countRetry = host.querySelector('[data-j4u-count-retry]');
    var more = host.querySelector('[data-j4u-more]');
    var retry = host.querySelector('[data-j4u-retry]');
    var clear = host.querySelector('[data-j4u-clear]');
    var state = parseState(win.location.href, config);
    var ledger = new PageLedger();
    var controller = null, generation = 0, busy = false, retryAppend = false;
    var autoLimit = AUTO_BATCH_SIZE;
    var countJob = null;
    var endpoint = '/api/' + API_VERSION + '/graphql.json';

    function number(value) { return value.toLocaleString(config.locale || 'en'); }
    function updateSummary() {
      if (config.mode !== 'search') { status.textContent = ledger.count ? '' : 'No matching products found.'; return; }
      if (countJob && countJob.result) {
        var total = state.hideSold ? countJob.result.available : countJob.result.total;
        status.textContent = number(total) + (total === 1 ? ' product' : ' products') + (state.hideSold ? ' · Hide Sold' : '');
        if (total === 0) status.textContent += ' · No matching products found.';
      } else if (countJob && countJob.error) {
        status.textContent = 'Total currently unavailable · ' + number(ledger.count) + ' products shown';
      } else { status.textContent = 'Counting matching products…'; }
    }
    function countKey() { return String(state.term || '').normalize('NFKC').trim().replace(/\s+/gu, ' '); }
    function cancelCount() {
      if (countJob) { countJob.cancelled = true; if (countJob.controller) countJob.controller.abort(); }
      countJob = null; countRetry.hidden = true;
    }
    function startCount(force) {
      if (config.mode !== 'search' || !state.term.trim()) return;
      var key = countKey();
      if (!force && countJob && countJob.key === key && (!countJob.finished || Date.now() - countJob.finished < 30000)) { updateSummary(); return; }
      cancelCount();
      var job = { key: key, cancelled: false, controller: null };
      countJob = job;
      var requestedState = Object.assign({}, state);
      updateSummary();
      countSearch(config, requestedState, async function (request) {
        job.controller = new win.AbortController();
        var timer = win.setTimeout(function () { job.controller.abort(); }, 20000);
        try {
          var response = await win.fetch(endpoint, { method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request), signal: job.controller.signal });
          if (!response.ok) throw new Error('Count unavailable');
          return await response.json();
        } finally { win.clearTimeout(timer); }
      }, null, function () { return job.cancelled; }).then(function (result) {
        if (job.cancelled || countJob !== job) return;
        job.result = result; job.finished = Date.now(); updateSummary();
      }).catch(function () {
        if (job.cancelled || countJob !== job) return;
        job.error = true; job.finished = Date.now(); countRetry.hidden = false; updateSummary();
      });
    }
    function canAutoLoad() { return !!win.IntersectionObserver && !busy && retry.hidden && ledger.hasNext && ledger.count < autoLimit; }
    function checkAutoLoad() {
      if (canAutoLoad() && sentinel.getBoundingClientRect().top < win.innerHeight + 700) load(true);
    }

    function money(value) {
      var amount = Number(value.amount);
      try { return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: value.currencyCode }).format(amount); }
      catch (_) { return value.currencyCode + ' ' + amount.toFixed(2); }
    }
    function renderProduct(product) {
      var item = element(doc, 'div', 'product grid__item medium-up--one-third small--one-half j4u-product');
      item.setAttribute('role', 'listitem');
      item.dataset.productId = product.id;
      item.dataset.available = String(product.availableForSale);
      var href = (config.root || '/') + 'products/' + encodeURIComponent(product.handle);
      // Keep the original theme selector used by the existing Wishlist app.
      var link = element(doc, 'a', 'j4u-product-image product__image-wrapper');
      link.href = href;
      link.setAttribute('aria-label', product.title);
      if (product.featuredImage) {
        var img = element(doc, 'img');
        img.src = product.featuredImage.url;
        img.alt = product.featuredImage.altText || product.title;
        img.loading = 'lazy'; img.decoding = 'async';
        if (product.featuredImage.width) img.width = product.featuredImage.width;
        if (product.featuredImage.height) img.height = product.featuredImage.height;
        link.appendChild(img);
      } else { link.appendChild(element(doc, 'span', 'j4u-no-image', 'No image')); }
      item.appendChild(link);
      var title = element(doc, 'div', 'product__title text-center');
      var titleLink = element(doc, 'a', '', product.title); titleLink.href = href; title.appendChild(titleLink); item.appendChild(title);
      if (config.showVendor && product.vendor) item.appendChild(element(doc, 'div', 'product__vendor text-center', product.vendor));
      var price = product.priceRange.minVariantPrice;
      var varied = Number(price.amount) !== Number(product.priceRange.maxVariantPrice.amount);
      var prices = element(doc, 'div', 'product__prices text-center');
      prices.appendChild(element(doc, 'span', 'product__price', (varied ? 'From ' : '') + money(price)));
      var compare = product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice;
      if (compare && Number(compare.amount) > Number(price.amount)) prices.appendChild(element(doc, 's', 'j4u-compare-price', money(compare)));
      if (!product.availableForSale) {
        var badge = element(doc, 'span', 'badge badge--sold-out');
        badge.appendChild(element(doc, 'span', '', 'Sold')); prices.appendChild(badge);
      }
      item.appendChild(prices);
      return item;
    }
    function updateControls() {
      form.elements.hide_sold.checked = state.hideSold;
      form.elements.sort_by.value = state.sort;
      clear.hidden = !state.hideSold;
    }
    var wishlist = null;
    function refreshWishlist() {
      if (doc.getElementById('J4UFavoritesConfig')) return;
      if (!wishlist || typeof wishlist.injectSwymButtonOnProductGrid !== 'function') return;
      try { wishlist.injectSwymButtonOnProductGrid(); }
      catch (error) { win.console.warn('Wishlist buttons could not be initialized.', error); }
    }
    // Swym and the product response can finish in either order. Refresh both
    // on app readiness and after every appended/replaced batch of cards.
    win.SwymCallbacks = win.SwymCallbacks || [];
    win.SwymCallbacks.push(function (swat) { wishlist = swat; refreshWishlist(); });
    function notifyProducts() {
      refreshWishlist();
      doc.dispatchEvent(new win.CustomEvent('j4u:products-rendered', { detail: { container: grid } }));
    }
    async function load(append) {
      if (append && (busy || !ledger.hasNext)) return;
      if (controller) controller.abort();
      controller = new win.AbortController();
      var activeController = controller;
      var current = ++generation;
      var requestedState = Object.assign({}, state);
      var previousCursor = append ? ledger.cursor : null;
      busy = true; retryAppend = append; retry.hidden = true; more.hidden = true;
      loading.textContent = 'Loading products…';
      if (!append) {
        grid.setAttribute('aria-busy', 'true'); ledger = new PageLedger(); grid.replaceChildren(); autoLimit = AUTO_BATCH_SIZE;
        if (countJob && countJob.key !== countKey()) cancelCount();
      }
      if (config.mode === 'search' && !requestedState.term.trim()) {
        status.textContent = 'Enter a product title to search.';
        loading.textContent = ''; busy = false; grid.setAttribute('aria-busy', 'false'); return;
      }
      if (!append) status.textContent = 'Loading products…';
      var timedOut = false;
      var timer = win.setTimeout(function () { timedOut = true; activeController.abort(); }, 20000);
      try {
        var request = buildRequest(config, requestedState, previousCursor);
        var response = await win.fetch(endpoint, {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request), signal: activeController.signal
        });
        if (!response.ok) throw new Error('Products could not be loaded. Please try again.');
        var payload = await response.json();
        if (current !== generation) return;
        var connection = connectionFrom(payload, requestedState, previousCursor);
        var products = ledger.append(connection);
        var fragment = doc.createDocumentFragment();
        products.forEach(function (product) { fragment.appendChild(renderProduct(product)); });
        grid.appendChild(fragment);
        updateSummary();
        startCount(false);
        loading.textContent = '';
        more.hidden = !ledger.hasNext || (!!win.IntersectionObserver && ledger.count < autoLimit);
        more.textContent = win.IntersectionObserver ? 'Continue browsing' : 'Show more products';
        notifyProducts();
      } catch (error) {
        if (current !== generation) return;
        if (error.name === 'AbortError' && !timedOut) return;
        loading.textContent = timedOut ? 'Loading took too long. Please try again.' : error.message;
        if (!append) status.textContent = 'Products could not be loaded.';
        retry.hidden = false;
      } finally {
        win.clearTimeout(timer);
        if (current === generation) { busy = false; grid.setAttribute('aria-busy', 'false'); win.requestAnimationFrame(checkAutoLoad); }
      }
    }
    function changeState() {
      state.hideSold = form.elements.hide_sold.checked;
      state.sort = sortName(form.elements.sort_by.value);
      win.history.pushState({}, '', stateURL(win.location.href, state, config));
      updateControls(); load(false);
    }
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    form.elements.hide_sold.addEventListener('change', changeState);
    form.elements.sort_by.addEventListener('change', changeState);
    clear.addEventListener('click', function () { form.elements.hide_sold.checked = false; changeState(); });
    more.addEventListener('click', function () { autoLimit = ledger.count + AUTO_BATCH_SIZE; load(true); });
    countRetry.addEventListener('click', function () { startCount(true); });
    retry.addEventListener('click', function () { load(retryAppend); });
    win.addEventListener('popstate', function () { state = parseState(win.location.href, config); updateControls(); load(false); });
    if (win.IntersectionObserver) {
      var observer = new win.IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) checkAutoLoad(); }, { rootMargin: '700px' });
      observer.observe(sentinel);
    }
    win.addEventListener('pagehide', function () { cancelCount(); if (controller) controller.abort(); });
    win.addEventListener('pageshow', function (event) { if (event.persisted) { state = parseState(win.location.href, config); updateControls(); load(false); } });
    updateControls(); load(false);
  }
  return { API_VERSION: API_VERSION, titleQuery: titleQuery, parseState: parseState, stateURL: stateURL, buildRequest: buildRequest, buildCountRequest: buildCountRequest, countSearch: countSearch, connectionFrom: connectionFrom, PageLedger: PageLedger, mount: mount };
});
